 import React, { useState, useEffect } from 'react';
import axios from 'axios';
import settings from '../../config/settings';
import './AdvanceSearch.css';
import { CRow, CButton, CCard, CCol, CInput, CCardBody, CCardSubtitle, CCardTitle, CInputGroup,CSelect, CContainer} from '@coreui/react';
 import { TheHeader } from '../../containers';
 import { useHistory } from "react-router";
import { Box, CircularProgress, Link } from '@material-ui/core';
import Checkbox from '@mui/material/Checkbox';
import AdvanceSearchFilePdf from './AdvanceSearchFilePdf';
import { handleApiError } from '../../session/session-expire';
import { ToastContainer, toast } from 'react-toastify';
import CreateIcon from '@mui/icons-material/Create';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const toast_options = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
   };
    

const loader = {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    background: "rgba(255,255,255,0.4)",
    zIndex: "9999",
    display: "table",
    width: "100%",
    height: "100%"
};
 
const AdvanceSearch = () => {
    const history = useHistory();
       const [searchQuery, setSearchQuery] = useState({ general: ""});
       const [options, setOptions] = useState({
        matchCase: false,
        matchWholeWord: false,
        useRegex: false,
      });
      const [noRecordFound, setNoRecordFound] = useState(false);
     const [queryLogic, setQueryLogic] = useState("KEYWORD MATCH");
      const [newResult, setNewResult] = useState([]);
     const [Isloader, setIsloader] = useState(false);
     const [pdfUrl, setPdfUrl] = useState('');
     const[selectedResult,setSelectedResult]=useState('');
     const [isSearchCompleted, setIsSearchCompleted] = useState(false);
     const[originalpdf,setOrginalPdf]=useState([])
     const [showPdfDrawer, setShowPdfDrawer] = useState(false); 
     const [currentPage, setCurrentPage] = useState(1);
     const [totalRecords, setTotalCount] = useState(1); 
     const [lastScrollY, setLastScrollY] = useState(0); 
     const [expandedContent, setExpandedContent] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        APINbr: [],
        WellName: [],
        Type:[],
        CompanyName: [],
        original_filename: [],
        CountyAPINumber: [],
    });
     const [filterOptions, setFilterOptions] = useState({
        APINbr: [],
         WellName: [],
         Type:[],
        CompanyName: [],
        original_filename: [],
        CountyAPINumber: [],
    });
     const itemsPerPage = 25;
     const suggestions = [
      {
        title: "Keyword Match",
        subtitle: "Please enter the search query with commas and spaces",
      },
      {
        title: "Stand out on social",
        subtitle: "What are some tips for writing a great post?",
      },
      {
        title: "Stand out on social",
        subtitle: "What are some tips for writing a great post?",
      },
      {
        title: "Exact Match",
        subtitle: "Please search a valid query without commas.",
      },
      {
        title: "Stand out on social",
        subtitle: "What are some tips for writing a great post?",
      },
      {
        title: "Stand out on social",
        subtitle: "What are some tips for writing a great post?",
      },
    ];
   useEffect(() => {
    const handleScroll = () => {

    };
  
      window.addEventListener("scroll", handleScroll);
  
       return () => {
        window.removeEventListener("scroll", handleScroll);
      };

    },  [lastScrollY]);
     
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    };
   
    const getShortContent = (content) => {
        if (!content) return '';  
        const words = content.split(' ');
        return words.slice(0, 100).join(' ') + (words.length > 100 ? '...' : '');
    };
  
    const handleClickMore = (index) => {
        setExpandedContent((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };
   
     const handleInputChange = (e) => {
        const { value } = e.target;
        setSearchQuery((prev) => ({ ...prev, general: value }));
      };
 
    const highlightText = (text, searchQuery, queryLogic) => {
        if (!text || !searchQuery.general.trim()) return text;
    
        const escapeSpecialChars = (string) => {
            return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        };
    
        const matchWholeWords = (text, searchWords) => {
            const wordBoundaryRegex = `\\b(${searchWords.join("|")})\\b`; 
            const regex = new RegExp(wordBoundaryRegex, "gi");
    
            return text.split(regex).map((part, index) =>
                regex.test(part) ? (
                    <span
                        key={index}
                        style={{
                            backgroundColor: "#ffff00",
                            display: "inline",
                            padding: "0",
                            margin: "0",
                        }}
                    >
                        {part}
                    </span>
                ) : (
                    part
                )
            );
        };
    
        if (queryLogic === "EXACT MATCH") {
             const escapedSearchQuery = escapeSpecialChars(searchQuery.general.trim());
            return matchWholeWords(text, [escapedSearchQuery]);
        } else if (queryLogic === "KEYWORD MATCH") {
             const searchWords = searchQuery.general.includes(',')
                ? searchQuery.general.split(',').map((phrase) => phrase.trim())  
                : searchQuery.general.split(/\s+/).map((word) => word.trim());  
    
            const escapedWords = searchWords.map((word) => escapeSpecialChars(word));
            return matchWholeWords(text, escapedWords);
        }
    
        return text;
    };
    
    
      const toggleOption = (option) => {
        setOptions((prevOptions) => ({
          ...prevOptions,
          [option]: !prevOptions[option],
        }));
      };
      const handleChange = (event) => {
        setQueryLogic(event.target.value);
      };
    
 
    const handleSearch = async (e, args = "submitBtn", pageNum = 0) => {
      e.preventDefault();
       if (!searchQuery.general.trim()) {
           toast.warn('Please enter at least one search term.', toast_options);

          return;
      }
      
       setIsloader(true);
      
      if (args === "submitBtn") {
          setNewResult([]);
          setCurrentPage(1);
      }
      
      try {
          const words = searchQuery.general.includes(',')
              ? searchQuery.general.split(',')
              : searchQuery.general.split(' ');
        
          let formattedText = "";
          let combinations = [];
          let searchText = "";
  
          if (queryLogic === "EXACT MATCH") {
               if (searchQuery.general.includes(',')) {
                         toast.warn('Please search a valid query without commas.', toast_options);
              }
              formattedText = `"${searchQuery.general}"`;
              searchText = formattedText;
          } else if (queryLogic === "KEYWORD MATCH") {
              const quotedWords = words.map((word) => `"${word.trim()}"`);
  
              if (quotedWords.length > 2) {
                  combinations.push(`(${quotedWords.join(" AND ")})^${quotedWords.length}`);
              }
  
              if (quotedWords.length >= 2) {
                  const pairCombinations = quotedWords
                      .map((word, i) =>
                          quotedWords.slice(i + 1).map((nextWord) => `(${word} AND ${nextWord})^${quotedWords.length - 1}`)
                      )
                      .flat();
  
                  combinations.push(...pairCombinations);
              }
  
              combinations.push(...quotedWords);
              searchText = combinations.join(" OR ");
          }
  
          const param = { text: searchText, skip: pageNum * itemsPerPage };
  
           const apiResponse = await axios.post(
              `${settings.serverUrl}/advance_ai_search`,
              param,
              { headers }
          );
          
           const results = apiResponse.data.results || [];
           if(results?.length === 0){
             setNoRecordFound(true)
           }
          setNewResult((prevResults) => [...prevResults, ...results]);
          setTotalCount(apiResponse.data.totalCount || 0);
          setFilterOptions({
              APINbr: [...new Set(results.map((item) => item.APINbr || ""))],
              WellName: [...new Set(results.map((item) => item.WellName || ""))],
              Type: [...new Set(results.map((item) => item.Type || ""))],
              CompanyName: [...new Set(results.map((item) => item.CompanyName || ""))],
              original_filename: [
                  ...new Set(results.map((item) => item.original_filename || "")),
              ],
              CountyAPINumber: [
                  ...new Set(results.map((item) => item.CountyAPINumber || "")),
              ],
          });
  
           setIsloader(false);
          setIsSearchCompleted(true);
          
      } catch (error) {
           console.error("Error:", error.response ? error.response.data : error.message);
          setIsloader(false);
          
           handleApiError(error, history);
      }
  };
  
  

        const updateFilterOptions = (currentFilters) => {
        const filteredData = newResult.filter((item) => { 
            return (
                (currentFilters.APINbr.length === 0 || currentFilters.APINbr.includes(item.APINbr)) &&
                 (currentFilters.WellName.length === 0 || currentFilters.WellName.includes(item.WellName)) &&
                 (currentFilters.Type.length === 0 || currentFilters.Type.includes(item.Type)) &&
                (currentFilters.CompanyName.length === 0 || currentFilters.CompanyName.includes(item.CompanyName)) &&
                (currentFilters.original_filename.length === 0 || currentFilters.original_filename.includes(item.original_filename)) &&
                (currentFilters.CountyAPINumber.length === 0 || currentFilters.CountyAPINumber.includes(item.CountyAPINumber))
            );
        });
        setFilterOptions({
            APINbr: [...new Set(filteredData.map((item) => item.APINbr))],
             WellName: [...new Set(filteredData.map((item) => item.WellName))],
             Type: [...new Set(filteredData.map((item) => item.Type))],
            CompanyName: [...new Set(filteredData.map((item) => item.CompanyName))],
            original_filename: [...new Set(filteredData.map((item) => item.original_filename))],
            CountyAPINumber: [...new Set(filteredData.map((item) => item.CountyAPINumber))],
        });
    };

    const handleFilterChange = (category, value) => {
        setSelectedFilters((prevState) => {
            const updatedFilters = { ...prevState };
            if (updatedFilters[category].includes(value)) {
                updatedFilters[category] = updatedFilters[category].filter((item) => item !== value);
            } else {
                updatedFilters[category].push(value);
            }
            updateFilterOptions(updatedFilters);
            return updatedFilters;
        });
    };

      const filteredResults = newResult.filter((item) => {
        return (
            (selectedFilters.APINbr.length === 0 || selectedFilters.APINbr.includes(item.APINbr)) &&  
             (selectedFilters.WellName.length === 0 || selectedFilters.WellName.includes(item.WellName)) &&
             (selectedFilters.Type.length === 0 || selectedFilters.Type.includes(item.Type)) &&
            (selectedFilters.CompanyName.length === 0 || selectedFilters.CompanyName.includes(item.CompanyName)) &&
            (selectedFilters.original_filename.length === 0 || selectedFilters.original_filename.includes(item.original_filename)) &&
            (selectedFilters.CountyAPINumber.length === 0 || selectedFilters.CountyAPINumber.includes(item.CountyAPINumber))
        );
    });

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
       const paginatedResults = filteredResults.slice(startIndex, endIndex);
        const filteredCount = filteredResults.length;
        const isFilterActive = Object.values(selectedFilters).some((filters) => filters.length > 0);
         const displayedCount = isFilterActive ? filteredCount : totalRecords;
    
    const handleNextPage = async (e) => {
        const startIndex = currentPage * itemsPerPage;
        if (startIndex >=filteredResults.length && startIndex < totalRecords) {
         
            
            await handleSearch(e,'NextBtn',currentPage);
            setCurrentPage((prevPage) => prevPage + 1);
        } else {
       
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
             setCurrentPage((prevPage) => prevPage - 1);
        }
    };
 
    const handleFilenameClick = async (filepath,fileName, message) => {
        try {
            setIsloader(true);
          const param = { fileName: fileName,filePath:filepath};
          const apiResponse = await axios.post(
            `${settings.serverUrl}/getSearchPdfFile`,
            param,
            { headers }
          );
           const results = apiResponse.data.result.base64Str;
           setPdfUrl(results);
          setSelectedResult(message)
          setShowPdfDrawer(true);
        } catch (error) {
          console.error('Error fetching PDF:', error);
          handleApiError(error, history);
        } finally {
            setIsloader(false);
        }
      };    
      const handleCloseDrawer = () => {
        setShowPdfDrawer(false);
      };
     
      
   
     return (
        <>
     
     <form onSubmit={(e) => handleSearch(e, "submitBtn")}>
      
         <TheHeader />
<Box className='advance_search_box'>
<div style={{position:"fixed", left:12, right:12, top:0, zIndex:1, height:172, background: "rgb(249, 249, 249)"}}></div>
            <CCard className="search_card">
            <div className='close_search' onClick={()=>history.goBack()}><i class="fa fa-times" aria-hidden="true"></i></div>
        <CCardBody style={{padding:12}}>

        {!isSearchCompleted && (
            <>
         <CCardTitle>Advance Search</CCardTitle>
        <CCardSubtitle className="mb-2 text-body-secondary">To obtain advanced Search Results, type your text here and search.</CCardSubtitle>
        </>
    )}
    {Isloader && (
                            <Box style={loader}>
                                <CircularProgress style={{ margin: "28% auto", display: "block" }} />
                            </Box>
                        )}   
        <CRow>
        <CCol lg={2} md={2} sm={1} xs={1}></CCol>
      <CCol xs={5}>
      <CRow>
        <div style={{ border: "1px solid #C8C8C8", borderRadius: "7px" }}>
                  <CInputGroup>
             <CInput
              type="text"
              placeholder="search..."
              value={searchQuery.general}
              onChange={handleInputChange}
              style={{ border: "0" }}
            />
          </CInputGroup>
        </div>
        </CRow>
      
      </CCol>
      <CCol xs={3}>
      <div style={{display:"table", width:"100px", borderSpacing:"10px 0"}}>
      <div className='select_bar' style={{display:"table-cell"}}>
   <CSelect
     size="sm"
     value={queryLogic}
     onChange={handleChange}
     className='toggle_select'>
     <option value="KEYWORD MATCH">Keyword Match</option>
     <option value="EXACT MATCH">Exact Match</option>
   </CSelect>
 </div>
        <CButton onClick={handleSearch} style={{display:"table-cell", whiteSpace:"nowrap"}}>
                            <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330.53 336">
                            <path class="cls-1" d="M845.34,439.48H965.87s7.88-4.18,7.72-9.32-4.66-8.84-5.79-9-122.46,0-122.46,0-18.32.64-30.54,15.91-12.37,31.18-12.37,31.18l.48,204.43s4.34,16.55,11.89,23.46,19.61,14,26.2,15.11,211.5,1.29,211.5,1.29,20.57-3.86,29.89-17.52,11.25-18,11.57-25.88,0-130.66,0-130.66-4.17-7.23-9.32-6.75-7.71,3.7-8.51,6.27-.65,132.91-.65,132.91-6.75,22.82-28.77,23-201.37.49-201.37.49-23.14-6.75-23.79-23.63-.48-207.8-.48-207.8S826.54,440.77,845.34,439.48Z" transform="translate(-802.43 -376.53)"/>
                            <path class="cls-1" d="M1029.57,381.14s-.11-4.5-4.18-4.6-5.46,1.6-6,3.42-10.93,61.72-31.39,74.68-37.39,21.86-56.79,24-15.42,7.4-15.42,7.4-.86,3.42,6.85,4.5,30,6.21,44,11.89,36.43,25.82,43,48.21,8,40.18,12.11,42.43,6.86-2.57,6.86-2.57,7.71-33.11,8.89-35.68,5.79-23.57,19-34.61,30.86-22.92,46.4-25.6,27-4.93,27-4.93,3.75-2.36,3-5.68-5.25-4.39-9.11-5-39.54-6.42-52.71-17-26.9-20.5-31.61-40.84C1039.43,421.09,1029.46,385.64,1029.57,381.14Z" transform="translate(-802.43 -376.53)"/>
                            <path class="cls-1" d="M921.6,552.22s0-2-1.87-2.07-2.45.72-2.69,1.54S912.13,579.38,903,585.2,886.18,595,877.48,596s-6.93,3.32-6.93,3.32-.38,1.54,3.08,2a109.71,109.71,0,0,1,19.76,5.34c6.29,2.54,16.34,11.58,19.27,21.63s3.61,18,5.43,19,3.08-1.15,3.08-1.15,3.46-14.85,4-16,2.6-10.57,8.51-15.52,13.84-10.29,20.81-11.49,12.12-2.21,12.12-2.21,1.68-1.06,1.34-2.55-2.35-2-4.08-2.26-17.74-2.89-23.65-7.64-12.07-9.2-14.18-18.33C926,570.14,921.56,554.24,921.6,552.22Z" transform="translate(-802.43 -376.53)"/>
                            <path class="cls-1" d="M1100.68,404.26s0-.81-.75-.83-1,.29-1.08.62-2,11.13-5.66,13.46-6.75,3.94-10.24,4.33-2.78,1.33-2.78,1.33-.16.62,1.23.81a44.28,44.28,0,0,1,7.94,2.15,15.44,15.44,0,0,1,7.75,8.69c1.18,4,1.45,7.24,2.18,7.65s1.24-.46,1.24-.46,1.39-6,1.6-6.44,1-4.25,3.42-6.24,5.56-4.13,8.36-4.61,4.87-.89,4.87-.89.67-.43.54-1-1-.8-1.64-.91-7.13-1.16-9.51-3.07-4.84-3.7-5.69-7.37C1102.46,411.46,1100.66,405.07,1100.68,404.26Z" transform="translate(-802.43 -376.53)"/>
                            </svg>
                            Search  
                        </CButton>
                        </div>
      </CCol>
      </CRow>
       
      </CCardBody>
            </CCard>
            {isSearchCompleted && (
            <Box className='search_header'>
                <CRow>
                    <CCol md={8}>
            <h4>Search Result</h4>
            </CCol>
            <CCol md={4} style={{textAlign:"right"}}>
             <CButton
                disabled={currentPage === 1}
                // disabled={currentPage === 1 && currentPage === 1}
                onClick={handlePreviousPage}
                style={{
                    backgroundColor: '#4ea7d8',
                    color: '#fff',
                    padding: '0px 12px',
                    marginRight: '10px',
                    border: 'none',
                    fontSize: '13px'
                }}
            >
                Pre
            </CButton>
        
          
            <span style={{ fontSize: '13px', marginRight: '10px', color:"#fff" }}>        
                {/* {(itemsPerPage*currentPage)-itemsPerPage} - {itemsPerPage*currentPage} of {totalRecords}                */}
                {(itemsPerPage * currentPage) - itemsPerPage} - {Math.min(itemsPerPage * currentPage, displayedCount)} of {displayedCount}
            </span>

            <CButton
             disabled={currentPage * itemsPerPage >= displayedCount}
                onClick={handleNextPage}
                style={{
                    backgroundColor: '#4ea7d8',
                    color: '#fff',
                    padding: '0px 12px',
                    marginLeft: '10px',
                    border: 'none',
                    fontSize: '13px'
                }}
            >
                Next
            </CButton>
            </CCol>
            </CRow>
        </Box>
        
            )}
    <CRow style={{marginTop: 80}}>
<div style={{marginBottom:'10px'}}>
</div>
<CCol md={3} >
{isSearchCompleted && (
<Box style={{ overflowY:"auto", overflowX:"hidden"}}>

<CCard className="search_menu">
    {newResult?.length > 0 && (
         Object.keys(filterOptions).map((key) => {
             const displayNames = {
                APINbr: 'API#',
                WellName: 'Well Name',
                Type:'Type',
                CompanyName: 'Company',
                original_filename: 'Filename',
                CountyAPINumber: 'County API Number',
            };

            return (
                <>       
               
                    <CCardTitle key={key}>{displayNames[key] || key}</CCardTitle>                   
                    <CCardBody>
                     {filterOptions[key].map((value, index) => (
                    <div key={`${key}-${index}`} style={{display:"table"}}>  
                    <label style={{display: "table",cursor:'pointer'}}>                                          
                                                <Checkbox
                                                 style={{display:"table-cell", verticalAlign: "top"}}
                                                    size="small"
                                                    {...label}
                                                    checked={selectedFilters[key].includes(value)}
                                                    onChange={() => handleFilterChange(key, value)}
                                                />
                                                <span style={{display:"table-cell"}}>
                                                    {value}
                                                </span>   
                                                </label>                                     
                                                </div>  
                      ))}                                        
                    </CCardBody>
                </>

            );
        })
    )}
    </CCard> 

</Box>
)}
</CCol>
 <CCol md={9}>
 
<Box style={{ overflowY: "auto", overflowX: "hidden" }}>
  {searchQuery && paginatedResults.length > 0 ? (
    paginatedResults.map((message, index) => (
      <>
        <CCard key={index} className="search_result">
          <CCardBody>
            <CRow>
              <CCol md={2}>
                <span>Filename:</span>
                <Link
                  onClick={() => {
                    setOrginalPdf({
                      path: message.file_breakup_container_path,
                      url: message.file_incoming_name
                    });
                    handleFilenameClick(
                      message.file_breakup_container_path,
                      message.file_breakup_name,
                      message
                    );
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {highlightText(message.original_filename, searchQuery, queryLogic)} / Page-{message.pageNumber}
                </Link>
              </CCol>
              <CCol md={2}><span>API#:</span><p>{highlightText(message.APINbr, searchQuery, queryLogic)}</p></CCol>
              <CCol md={2}><span>Company:</span><p>{highlightText(message.CompanyName, searchQuery, queryLogic)}</p></CCol>
              <CCol md={2}><span>Well Name:</span><p>{highlightText(message.WellName, searchQuery, queryLogic)}</p></CCol>
              <CCol md={2}><span>Date Completion:</span><p>{highlightText(message.DateCompletion, searchQuery, queryLogic)}</p></CCol>
              <CCol md={2}><span>Type:</span><p>{highlightText(message.Type, searchQuery,queryLogic)}</p></CCol>
            </CRow>
            <hr />
            <p>
              {expandedContent[index]
                ? highlightText(message.pdf_content, searchQuery, queryLogic)
                : highlightText(getShortContent(message.pdf_content), searchQuery, queryLogic)}
            </p>

            {message.pdf_content && message.pdf_content.split(" ").length > 100 && (
              <span
                className="btn_link"
                style={{ cursor: "pointer" }}
                onClick={() => handleClickMore(index)}
              >
                {expandedContent[index] ? (
                  <>
                    Read Less <i className="fa fa-chevron-up" aria-hidden="true"></i>
                  </>
                ) : (
                  <>
                    Read More <i className="fa fa-chevron-down" aria-hidden="true"></i>
                  </>
                )}
              </span>
            )}
          </CCardBody>
        </CCard>
      </>
    ))
  ) : (paginatedResults.length === 0 && !Isloader && !noRecordFound)?(
      <div style={{left:"0", position:"absolute",zIndex:10, width:"100%"}}>
      <CContainer className="suggession_box">
  {suggestions.map((suggestion, index) => (
    <div className="select_match_box" key={index}>
      <div className="box_icon_text">
        <CreateIcon style={{ color: "#4EA7D8" }} />
        <CCardTitle style={{ marginLeft: "5px", fontSize: "16px" }}>
          {suggestion.title}
        </CCardTitle>
      </div>
      <CCardSubtitle
        style={{ marginTop: "10px", fontSize: "14px", color: "#2C384AAE" }}
      >
        {suggestion.subtitle}
      </CCardSubtitle>
    </div>
  ))}
</CContainer>
        </div>
  ):searchQuery.general.length>0 && searchQuery && !Isloader && noRecordFound &&
  <CRow>
      <CCol md={8}>
        <Box className="no_results">No record Found!!</Box>
      </CCol>
      <CCol md={4}></CCol>
    </CRow>
  }
</Box>



</CCol>
</CRow>
      <ToastContainer style={{width:'450px'}}/>
</Box>
        </form>
                               <AdvanceSearchFilePdf
                                    isOpen={showPdfDrawer}
                                    onClose={handleCloseDrawer}
                                    fileUrl={pdfUrl}  
                                    selectedResult={selectedResult}
                                    originalpdf={originalpdf}
                                    searchQuery={searchQuery}
                                    queryLogic={queryLogic}
                                 /> 
    
        

        </>
    );
};

export default AdvanceSearch;